import React from 'react';
import ComingSoon from '../ComingSoon';

// TODO(data): wire to PHP requestsList / businesses-for-user (exists) — Phase 3.
const RequestsNBues = () => (
    <ComingSoon title="העסקים שלי" note="ניהול העסקים והבקשות יתווסף בקרוב." />
);

export default RequestsNBues;
